import { render, staticRenderFns } from "./RestaurantAddress.vue?vue&type=template&id=4b64d7ba&scoped=true&"
import script from "./RestaurantAddress.vue?vue&type=script&lang=js&"
export * from "./RestaurantAddress.vue?vue&type=script&lang=js&"
import style0 from "./RestaurantAddress.vue?vue&type=style&index=0&id=4b64d7ba&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@nuxt/webpack/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b64d7ba",
  null
  
)

export default component.exports